import React, { useMemo } from 'react';
import { createSubstyle, PropsDecoratorProvider } from 'substyle';
import createPropsDecorator from './createPropsDecorator';
export var viaJss = function viaJss(style, jss) {
  return createSubstyle({
    style: style
  }, createPropsDecorator(jss));
};
export var StylesViaJss = function StylesViaJss(_ref) {
  var jss = _ref.jss,
      children = _ref.children;
  var propsDecorator = useMemo(function () {
    return createPropsDecorator(jss);
  }, [jss]);
  return /*#__PURE__*/React.createElement(PropsDecoratorProvider, {
    value: propsDecorator
  }, children);
};